import React, { useState, useEffect } from 'react';
import { Container, VStack } from "@chakra-ui/react";

import generatePageModules from "../helpers/PageModuleHandler";
import { HomePageSectionsType } from "../types/homePageTypes";
import Snackbar from "../Snackbar/Snackbar";
import LoadingScreen from "../../assets/react/Loading";

// Tiffr object interface 
declare global {
  interface Window {
      TIFFR?: {
        addShortlistButtons?: () => void,
        setSelections?: () => void
      };
  }
}

const Home = () => {
  const DATA_ENDPOINT = "/data/homepage";

  const [homePageSections, setHomePageSections] = useState<HomePageSectionsType | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // load home page data
  useEffect(() => {
    const fetchHomePageData = async () => {
      try {
        const response = await fetch(DATA_ENDPOINT);

        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }

        const json: any = await response.json();
        setHomePageSections(json);
      }

      catch (err: any) {
        setError(err.message);
        console.error("Error fetching the homepage sections data:", err.message)
      }

      finally {
        setLoading(false);
      }
    };

    fetchHomePageData();
  }, []);

  // load Tiffr script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://tiffr.com/assets/widget.js";
    script.async = true;
    script.setAttribute('data-tiffr-festival', '2024');
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    }
  }, []);

  useEffect(() => {
    // add heart icons on component update
    setTimeout(() => {
      if(window.TIFFR){
        if(window.TIFFR.addShortlistButtons && typeof window.TIFFR.addShortlistButtons === "function") window.TIFFR.addShortlistButtons();
        if(window.TIFFR.setSelections && typeof window.TIFFR.setSelections === "function") window.TIFFR.setSelections();
      }
    }, 200);
  }, [homePageSections])

  if (error) {
    console.log("Error in fetching home page data: ", error);
  }

  if (loading) return <LoadingScreen />;

  if (homePageSections) {
    // loaded but no home page sections added
    if (homePageSections.pageSectionsBottom.length === 0) {
      console.log("Home page sections are empty. Check Contentful or HomeController setup.")
      return (
        <Container minH="1080px">No data loaded.</Container>
      )
    }

    // loaded
    if (homePageSections.pageSectionsBottom.length > 0) {
      const pageModulesData = homePageSections.pageSectionsBottom;
      const snackbarData = homePageSections.snackbar;
      const activeSeasonFilms = homePageSections.activeSeasonFilms

      return (
        <Container maxW='unset' minH='1400px' m="0" p="0">
          <VStack alignItems="stretch" marginBottom="1rem">
            { generatePageModules(pageModulesData, loading, activeSeasonFilms) }
          </VStack>
          <Snackbar {...snackbarData } />
        </Container>
      )
    }
  }

  return null;
}

export default Home;